export default {
    change_puls_customer_title: "Change Calamp Account",
    change_puls_customer_label: "Calamp Account",
    change_puls_customer_account_label: "Calamp Account",
    change_puls_customer_input: "IMEI or Serial",
    change_puls_customer_imei: "IMEI",
    change_puls_customer_serial: "Serial",
    change_puls_customer_model: "Model",
    change_puls_customer_change: "Change",
    change_puls_customer_no_devices_added: "No devices added",
    change_puls_customer_device_is_already_added: "The device is already added",
    change_puls_customer_device_has_not_been_found: "The device has not been found",
    change_puls_customer_this_feature_is_not_available: "This feature is not available",
    change_puls_customer_single_success_message: "The Calamp Account of the device has been changed",
    change_puls_customer_multiple_success_message: "The Calamp Account of the devices has been updated",
    change_puls_customer_error_message: "Unable to change Calamp Account due to an error",
    change_puls_customer_status: "Status",
    change_puls_customer_message: "Message",
}

